import { styled } from '@mui/material/styles';
import { IconButton } from 'components/ui/IconButton';
import { getThemeSpacingCssPx } from 'components/ui/utilities/theme';
import { getCssPx } from 'components/ui/utilities/zoom';

interface FolderActionsRootStyleProps {
  isMenuOpen?: boolean;
}

const shouldForwardRootProp = (prop: PropertyKey) => prop !== 'isMenuOpen';

export const FirmDocumentFolderActionsRoot = styled('div', {
  shouldForwardProp: shouldForwardRootProp,
})<FolderActionsRootStyleProps>(({ isMenuOpen = false, theme }) => ({
  '--icon-button-compact-icon-size': getCssPx(16),
  '--icon-button-compact-size': getCssPx(20),
  '--icon-button-radius': getCssPx(theme.shape.radius.xs),
  '--firm-document-folder-actions-gap': getThemeSpacingCssPx(theme, 'xs'),
  alignItems: 'center',
  display: 'inline-flex',
  flex: '0 0 auto',
  gap: 'var(--firm-document-folder-actions-gap)',
  minWidth: 0,
  opacity: isMenuOpen ? 1 : 0,
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export const FirmDocumentFolderActionTrigger = styled(IconButton)(({ theme }) => ({
  '&:focus-visible': {
    boxShadow: `0 0 0 1px ${theme.palette.brand[400]}`,
    outline: 0,
  },
}));
